import { render, staticRenderFns } from "./GrantAuthoritySearchTable.vue?vue&type=template&id=a884566c&scoped=true&"
import script from "./GrantAuthoritySearchTable.vue?vue&type=script&lang=ts&"
export * from "./GrantAuthoritySearchTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a884566c",
  null
  
)

export default component.exports